/* This file is autogenerated, see readme.md for instructions */
import MetricAltSvgIcon from '@bloomreach/banana-theme/icons/metric-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MetricAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <MetricAltSvgIcon />
    </Icon>
  );
});

MetricAltIcon.displayName = 'MetricAltIcon';

export default MetricAltIcon;
